// Mock data for Student & Parent, Researcher, Coaching, Partners, Explore, and shared pages

export const STUDENT = {
  hero: {
    eyebrow: 'STUDENTS + PARENTS',
    title: 'Understand difficult concepts. Explore beyond the textbook.',
    desc:  'Immersive Science and Mathematics for Grades 8 and 9.',
    signOff: 'An institution-connected experience through your school',
  },
  strip: [
    { k: 'GRADES',   v: '8 and 9' },
    { k: 'SUBJECTS', v: 'Science + Mathematics' },
    { k: 'LANGUAGES',v: 'English · Hindi · Assamese' },
    { k: 'ACCESS',   v: 'Offline-first' },
    { k: 'DEVELOPED AT', v: 'Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati' },
  ],
  audiences: {
    students: [
      'Immersive VR journeys that make concepts click',
      'Practise with unlimited conceptual and applied quizzes',
      'Explore beyond textbooks with curated learning experiences',
      'Track individual learning progress',
    ],
    parents: [
      'See how your child engages with Gyan Dhara',
      'View learning time and quiz completion at a glance',
      'Multilingual explanations available in Hindi and Assamese',
      'Receive gentle reminders and learning summaries',
    ],
  },
  ways: [
    { title: 'Learn in VR',              desc: 'Guided immersive journeys through complex ideas and scientific systems.' },
    { title: 'Practise and understand',  desc: 'Conceptual, theoretical and applied quizzes tied to chapter learning.' },
    { title: 'Understand progress',      desc: 'Learning time, module completion and quiz analytics in one place.' },
  ],
  journeys: [
    { title: 'Taj Mahal',           theme: 'Age of Dinosaurs',       gradient: 'from-purple to-royal' },
    { title: 'Qutub Minar',         theme: 'Living World Safari',    gradient: 'from-royal to-cyan' },
    { title: 'India Gate',          theme: 'Experience Space Station', gradient: 'from-cyan to-mint' },
    { title: 'Age of Dinosaurs',    theme: 'Living World Safari',    gradient: 'from-mint to-royal' },
    { title: 'Living World Safari', theme: 'Experience Space Station', gradient: 'from-purple to-cyan' },
    { title: 'Experience Space Station', theme: 'India Gate',        gradient: 'from-royal to-purple' },
  ],
  visualCards: [
    { title: 'Visual videos',     desc: 'Short explainer videos to introduce each topic gently.' },
    { title: 'Visual resources',  desc: 'PDFs and reading resources that follow the immersive experience.' },
    { title: 'Unlimited quizzes', desc: 'Practise conceptually, theoretically and by application.' },
    { title: 'Gyan Mitra',        desc: 'An AI learning companion available in multiple languages.' },
  ],
  hubMetrics: [
    { k: '6h 25m', label: 'Learning overview time' },
    { k: '8 / 12', label: 'Modules completed' },
    { k: '76%',    label: 'Average score' },
  ],
  progress: [
    { icon: 'Compass',        title: 'Choose a module',       desc: 'Select a subject or exploratory journey.' },
    { icon: 'PlayCircle',     title: 'Immersive experience',  desc: 'Guided VR modules deepen understanding.' },
    { icon: 'ClipboardCheck', title: 'Practise and assess',   desc: 'Take quizzes tied to the concept.' },
    { icon: 'Repeat',         title: 'Revisit as needed',     desc: 'Return to modules until concepts are clear.' },
    { icon: 'BarChart3',      title: 'Track progress',        desc: 'See completion, time and scores over time.' },
  ],
};

export const RESEARCH = {
  hero: {
    eyebrow: 'RESEARCH + COLLABORATION',
    title: 'A living research platform for immersive learning',
    desc:  'Gyan Dhara brings together design research, learning sciences, immersive technology and school-based evaluation to understand how students learn difficult concepts.',
  },
  strip: [
    { k: 'HOME INSTITUTION', v: 'Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati' },
    { k: 'CURRENT CONTEXT',  v: 'Grade 8–9 Science and Mathematics' },
    { k: 'FIELD SETTING',    v: 'Schools in Assam' },
    { k: 'LANGUAGES',        v: 'English · Hindi · Assamese' },
  ],
  purposes: [
    { title: 'Conceptual understanding', desc: 'How students form clearer explanations of difficult concepts.',                     icon: 'ScrollText',  color: 'purple' },
    { title: 'Mental-model clarity',      desc: 'How agentive and interactive representations shape internal understanding.',        icon: 'Brain',        color: 'royal' },
    { title: 'Applied transfer',          desc: 'How learners can use knowledge in unfamiliar and real-world situations.',           icon: 'Zap',         color: 'cyan' },
    { title: 'Learning experience',       desc: 'Engagement, usability, comfort and classroom feasibility.',                          icon: 'BarChart3',   color: 'mint' },
  ],
  fieldStudy: {
    title: 'Repeated-measures school evaluation',
    desc:  'Students complete pre-learning, post-learning and retention assessments around immersive modules. Module order is counterbalanced to reduce sequence effects.',
    rows: [
      { k: 'PARTICIPANTS', v: 'Grade 8 and 9 learners' },
      { k: 'MODULES',      v: 'Sound · Combustion & Flame · Area 2D' },
      { k: 'MEASURES',     v: 'Conceptual · Applied · Theoretical' },
      { k: 'CONTEXT',      v: 'Two school field study' },
    ],
  },
  approach: [
    { title: 'Identify learning difficulty', desc: 'Teacher consultation and classroom observation.',                   step: 1 },
    { title: 'Design the experience',        desc: 'Learning outcomes, interaction and representation decisions.',      step: 2 },
    { title: 'Evaluate in context',           desc: 'Pre, post, attention and perception measures.',                    step: 3 },
    { title: 'Translate findings',            desc: 'Design improvements, reports and responsible dissemination.',      step: 4 },
  ],
  collabAreas: [
    { title: 'Joint evaluation studies', desc: 'Co-design evaluation protocols, instruments and analysis plans.',      icon: 'Beaker' },
    { title: 'Learning sciences',        desc: 'Study mental models, conceptual change, transfer and retention.',       icon: 'Brain' },
    { title: 'HCI and accessibility',    desc: 'Usability, immersive design, multilingual interaction and comfort.',     icon: 'Accessibility' },
    { title: 'Data and analytics',       desc: 'Develop meaningful learning indicators and responsible reporting.',      icon: 'BarChart3' },
    { title: 'Thesis and student projects', desc: 'Structured dissertation, internship or supervised research engagement.', icon: 'GraduationCap' },
    { title: 'Ethics and responsible research', desc: 'Consent, privacy, governance and appropriate dissemination.',      icon: 'ShieldCheck' },
  ],
};

export const COACHING = {
  hero: {
    eyebrow: 'FOR COACHING INSTITUTES',
    title: 'Add immersive concept learning to your institute',
    desc:  'Use Gyan Dhara as a structured experiential-learning layer for Grade 8 and 9 Science and Mathematics, without replacing your existing classes or teaching approach.',
  },
  strip: [
    { k: 'GRADES',   v: '8 and 9' },
    { k: 'SUBJECTS', v: 'Science + Mathematics' },
    { k: 'LANGUAGES',v: 'English · Hindi · Assamese' },
    { k: 'USE MODEL',v: 'Scheduled learning sessions' },
    { k: 'CORE ACCESS', v: 'Offline-first' },
  ],
  reasons: [
    { title: 'Explain difficult concepts visually', desc: 'Use interactive experiences where diagrams and verbal explanations are not enough.',            icon: 'Eye',          color: 'purple' },
    { title: 'Extend practice beyond worksheets',   desc: 'Provide unlimited conceptual, theoretical and applied quizzes.',                             icon: 'ClipboardList', color: 'royal' },
    { title: 'Understand learner progress',           desc: 'Review time spent, completion and chapter-level quiz performance.',                            icon: 'BarChart3',    color: 'cyan' },
    { title: 'Create a scheduled learning slot',       desc: 'Run a dedicated Gyan Dhara period, lab session or optional enrichment block.',              icon: 'CalendarClock', color: 'mint' },
  ],
  usage: [
    { title: 'Concept reinforcement', desc: 'Use after teaching a difficult chapter.',                icon: 'Repeat' },
    { title: 'Scheduled lab session', desc: 'Assign a regular VR learning period.',                    icon: 'CalendarClock' },
    { title: 'Revision support',       desc: 'Assign VR with quizzes and chapter resources.',           icon: 'BookOpen' },
    { title: 'Exploration block',      desc: 'Optional interdisciplinary experiences.',                 icon: 'Compass' },
  ],
  setup: [
    { title: 'Minimum starting setup', desc: 'At least three Meta Quest 3S headsets with recommended straps and stools.',           icon: 'Cpu' },
    { title: 'Recommended capacity',   desc: 'For up to 20 students, with one learner using one headset at a time.',                 icon: 'Users2' },
    { title: 'Offline-first operation', desc: 'Core installed modules work offline. Gyan Mitra requires internet.',                  icon: 'Wifi' },
    { title: 'Complete software access', desc: 'Offers software access like schools June 2027; 2027 updates and new modules included.', icon: 'BadgeCheck' },
  ],
};

export const PARTNERS = {
  hero: {
    eyebrow: 'PARTNERSHIPS FOR SCALE',
    title: 'Bring immersive learning to more students',
    desc:  'Government departments, CSR programmes, implementation partners and other organisations can work with Gyan Dhara to enable responsible, curriculum-aligned deployment at scale.',
  },
  strip: [
    { k: 'DEVELOPED AT',   v: 'Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati' },
    { k: 'CURRENT FOCUS',  v: 'Grade 8–9 Science and Mathematics' },
    { k: 'LANGUAGES',      v: 'English · Hindi · Assamese' },
    { k: 'OPERATION',      v: 'Offline-first' },
    { k: 'EVIDENCE',       v: 'Field evaluation underway' },
  ],
  who: [
    { title: 'Government departments', desc: 'State, district or institutional programmes that want structured school deployment.',              icon: 'Landmark',      color: 'purple' },
    { title: 'CSR and foundations',    desc: 'Organisations funding education access to hardware, logistics and implementation.',             icon: 'HeartHandshake', color: 'royal' },
    { title: 'Implementation partners', desc: 'Regional partners supporting coordination, training, installation and field operations.',       icon: 'Handshake',      color: 'cyan' },
    { title: 'Other organisations',    desc: 'Education, research, technology or social impact organisations with a relevant contribution.',   icon: 'Network',        color: 'mint' },
  ],
  why: [
    { title: 'Scale meaningful learning',  desc: 'Extend official Science and Mathematics concepts beyond diagrams and lectures.',              icon: 'ArrowUpRightSquare' },
    { title: 'Reach diverse learners',      desc: 'Support government, semi-private and private institutions without limiting module access.', icon: 'Users2' },
    { title: 'Build responsible evidence',  desc: 'Backed implementation and structured evaluation and transparent reporting.',                 icon: 'ClipboardCheck' },
    { title: 'Strengthen local capacity',   desc: 'Prepare coordinators, teachers, IT staff and student champions for sustained use.',           icon: 'BookOpen' },
  ],
  pathways: [
    { title: 'Public programme',           desc: 'Government-led deployment across selected schools or districts.',                            color: 'purple' },
    { title: 'CSR-supported deployment',    desc: 'CSR-partner funds hardware, logistics and agreed implementation support.',                 color: 'royal' },
    { title: 'Implementation partnership', desc: 'A local partner coordinates onboarding, training and local operations.',                    color: 'cyan' },
    { title: 'Strategic collaboration',    desc: 'An organisation contributes research, technology, accessibility or specialised content expertise.', color: 'mint' },
  ],
  ecosystem: [
    { title: 'Curriculum VR modules', desc: 'NCERT-aligned Grade 8–9 Science and Mathematics modules.',   icon: 'Layers' },
    { title: 'Exploration',           desc: 'Space, history, art, nature and interdisciplinary experiences.', icon: 'Globe' },
    { title: 'Assessment',            desc: 'Unlimited conceptual, theoretical and applied quizzes.',        icon: 'ClipboardCheck' },
    { title: 'Analytics',             desc: 'Completion, time spent, chapter activity and quiz performance.', icon: 'BarChart3' },
    { title: 'Gyan Mitra',            desc: 'English, Hindi and Assamese Q&A when internet is available.',   icon: 'MessageSquare' },
    { title: 'Updates',               desc: 'New modules and software updates through June 2027.',           icon: 'RefreshCw' },
  ],
  metrics: [
    { k: '60',   label: 'Schools planned',   note: 'Assam Vidyalaya deployment target.' },
    { k: '8–9', label: 'Grades',             note: 'Science and Mathematics.' },
    { k: '3',    label: 'Languages',          note: 'English, Hindi and Assamese.' },
    { k: '2027', label: 'Access period',      note: 'No software licence fee through June.' },
  ],
};

export const EXPLORE = {
  hero: {
    eyebrow: 'EXPLORE WITHOUT SELECTING A ROLE',
    title: 'Understand Gyan Dhara before choosing how to use it',
    desc:  'Explore the learning ecosystem, curriculum modules, exploratory journeys and operating model without committing to a school, family, research or partnership pathway.',
  },
  strip: [
    { k: 'DEVELOPED AT',       v: 'Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati' },
    { k: 'CURRENT LEARNING',   v: 'Grade 8–9 Science and Mathematics' },
    { k: 'LANGUAGES',           v: 'English · Hindi · Assamese' },
    { k: 'CORE OPERATION',      v: 'Offline-first' },
    { k: 'SOFTWARE ACCESS',     v: 'No licence fee through June 2027' },
  ],
  ways: [
    { letter: 'VR', title: 'Learn in VR',        desc: 'Guided immersive modules for concepts that are difficult to understand through conventional explanation alone.', color: 'purple' },
    { letter: 'Q',  title: 'Practise and assess',  desc: 'Unlimited conceptual, theoretical and applied quizzes connected to chapter learning.',   color: 'royal' },
    { letter: 'R',  title: 'Continue learning',    desc: 'Chapter videos, visual images, visual PDFs and teacher-provided resources.',              color: 'cyan' },
    { letter: 'A',  title: 'Understand progress',   desc: 'Completion, time spent and quiz performance for learners with individual accounts.',    color: 'mint' },
  ],
  audiencePaths: [
    { letter: 'S',  title: 'Student or Parent',           desc: 'Individual family learning and progress.' },
    { letter: 'SC', title: 'School or Institution',       desc: 'Classroom use, deployment and school operations.' },
    { letter: 'CI', title: 'Coaching Institute',          desc: 'Scheduled learning and compact adoption.' },
    { letter: 'RU', title: 'Researcher or University',    desc: 'Research activities, evidence and collaboration.' },
    { letter: 'P',  title: 'Government, CSR or Partner',   desc: 'Programme scale, funding and implementation.' },
  ],
};

export const ABOUT = {
  hero: { title: 'About Gyan Dhara', desc: 'An immersive learning ecosystem developed to help students understand, apply and retain difficult concepts through VR, assessment and learning analytics.' },
  principles: [
    { title: 'Conceptual clarity',      desc: 'Learning experiences are designed around mental models and difficult-to-visualise concepts.', icon: 'ScrollText',   color: 'purple' },
    { title: 'Experiential application', desc: 'Students act, test and observe instead of only reading or watching.',                     icon: 'Beaker',        color: 'royal' },
    { title: 'Joyful exploration',      desc: 'Curiosity and discovery support sustained engagement.',                                      icon: 'Sparkles',      color: 'cyan' },
    { title: 'Inclusive access',        desc: 'English, Hindi and Assamese support broader classroom use.',                                icon: 'Globe',         color: 'mint' },
    { title: 'Evidence-led design',      desc: 'Field trials and learning assessments guide product improvement.',                          icon: 'BarChart3',     color: 'purple' },
  ],
  spaces: [
    { name: 'Gyan Prangan', desc: 'Central entry and orientation space' },
    { name: 'Gyan Kaksha',  desc: 'Curriculum-aligned immersive classrooms' },
    { name: 'Gyan Vatika',  desc: 'Exploratory experiences beyond textbooks' },
    { name: 'Gyan Vriksha', desc: 'Events, talks and shared learning' },
    { name: 'Gyan Mitra',   desc: 'Multilingual AI learning companion' },
    { name: 'Gyan Setu',    desc: 'School, teacher and learner connection layer' },
  ],
};

export const TEAM = {
  hero: { title: 'Team and collaborators', desc: 'Gyan Dhara is developed through collaboration between design researchers, UX designers, VR developers, technical artists, school educators and students.' },
  leadership: { name: 'Dr. Keyur Sorathia', role: 'Principal Investigator · Associate Professor, Department of Design, IIT Guwahati' },
  members: [
    { name: 'UX Designer',           role: 'Role & current contribution', gradient: 'from-cyan to-royal' },
    { name: 'Learning Sciences',      role: 'Role & current contribution', gradient: 'from-mint to-royal' },
    { name: 'VR Developer',           role: 'Role & current contribution', gradient: 'from-orange-400 to-purple' },
    { name: 'Technical Artist',       role: 'Role & current contribution', gradient: 'from-purple to-cyan' },
    { name: 'Research Assistant',     role: 'Role & current contribution', gradient: 'from-royal to-purple' },
    { name: 'Content Designer',       role: 'Role & current contribution', gradient: 'from-mint to-cyan' },
  ],
  schools: Array.from({ length: 8 }, (_, i) => ({
    name: 'Teacher collaborator', school: 'School · Subject',
    gradient: ['from-orange-400 to-purple', 'from-purple to-royal', 'from-cyan to-purple', 'from-mint to-royal'][i % 4],
  })),
};

export const INSIGHTS = [
  {
    slug: 'education-quality-as-the-engine-of-india-s-growth-by-2047',
    title: 'Education Quality as the Engine of India\u2019s Growth by 2047',
    date: 'Oct 18, 2025', read: '3 min read', author: 'Dr. Keyur Sorathia',
    desc: 'India\u2019s vision for 2047 is bold. Central to that ambition is how well we educate our children today\u2014education quality, not just enrollment, is the true driver of long-term growth.',
    img: 'https://static.wixstatic.com/media/8d4e1c_d0dd234e652b40d2b0027766b23f4340~mv2.png/v1/fill/w_800,h_600,fp_0.50_0.50,q_95,enc_auto/8d4e1c_d0dd234e652b40d2b0027766b23f4340~mv2.png',
  },
  {
    slug: 'the-purpose-of-gyan-dhara',
    title: 'The purpose of Gyan Dhara',
    date: 'Sep 30, 2025', read: '2 min read', author: 'Dr. Keyur Sorathia',
    desc: 'Why Gyan Dhara exists and how it aligns with India\u2019s 2047 vision for classrooms that build clarity, confidence and curiosity.',
    img: 'https://static.wixstatic.com/media/8d4e1c_cdb78c3e472245ab83b72c0952658b5ff000.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_90,enc_auto/8d4e1c_cdb78c3e472245ab83b72c0952658b5ff000.jpg',
    hasVideo: true,
  },
  {
    slug: 'unlocking-maths-teachers-map-student-struggles-xr-s-potential',
    title: "Unlocking Maths: Teachers Map Student Struggles & XR's Potential",
    date: 'Aug 9, 2025', read: '4 min read', author: 'Dr. Keyur Sorathia',
    desc: 'Insights from a two-day workshop at IIT Guwahati with Class 8 and 9 mathematics teachers. What students struggle with and where XR can help.',
    img: 'https://static.wixstatic.com/media/8d4e1c_a687f6f23ccc4930b61479724f63c4b1~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_90,enc_auto/8d4e1c_a687f6f23ccc4930b61479724f63c4b1~mv2.jpg',
  },
  {
    slug: 'unlocking-science-insights-from-gyan-dhara-s-2-day-workshop-with-science-teachers-in-assam',
    title: 'Unlocking Science: Insights from Gyan Dhara\u2019s 2-Day Workshop with Science Teachers in Assam',
    date: 'Aug 5, 2025', read: '4 min read', author: 'Dr. Keyur Sorathia',
    desc: 'Nine science teachers from Adarsha Vidyalayas surfaced Grade 8\u20139 concepts where immersive learning can add the most value.',
    img: 'https://static.wixstatic.com/media/8d4e1c_67862622a21c436680016a06bf4291b8~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_90,enc_auto/8d4e1c_67862622a21c436680016a06bf4291b8~mv2.jpg',
  },
];

export const NEWS_ITEMS = [
  { title: 'Press Trust of India',  color: 'purple', url: 'https://www.ptinews.com/story/national/IIT-Guwahati-developing-India-s-first-VR-enabled-metaverse-platform-for-PM-SHRI-schools-in-Assam/2368019' },
  { title: 'The Week',              color: 'purple', url: 'https://www.theweek.in/wire-updates/national/2025/03/12/del12-iit-metaverse-schools.html' },
  { title: 'Business Standard',     color: 'amber',  url: 'https://www.business-standard.com/technology/tech-news/iit-guwahati-developing-india-s-1st-vr-metaverse-for-pm-shri-schools-125031200262_1.html' },
  { title: 'Hindustan Times',       color: 'royal',  url: 'https://www.hindustantimes.com/education/features/iit-guwahati-developing-indias-first-vr-enabled-metaverse-platform-for-pm-shri-schools-101741763421778.html' },
  { title: 'Economic Times',        color: 'purple', url: 'https://www.hindustantimes.com/education/features/iit-guwahati-developing-indias-first-vr-enabled-metaverse-platform-for-pm-shri-schools-101741763421778.html' },
  { title: 'Times of India',        color: 'royal',  url: 'https://timesofindia.indiatimes.com/city/guwahati/iit-g-set-to-launch-virtual-reality-labs-to-help-students-to-grasp-complex-concepts/articleshow/118946252.cms' },
];

export const CAREERS_LIST = [
  { title: 'Junior VR Developer',      details: 'Location · Engagement type · Key skills' },
  { title: 'Research or Design Internship', details: 'Duration · Eligibility · Key responsibilities' },
];

export const PROJECT_OVERVIEW = {
  hero: { title: 'Gyan Dhara at a glance', desc: 'A concise institutional overview of the vision, learning ecosystem, current scope and school deployment model.' },
  ecosystem: [
    { title: 'VR learning',           desc: 'Self-guided immersive modules for concepts that are difficult to visualise.', letter: 'VR', color: 'purple' },
    { title: 'AI-powered practice',   desc: 'Unlimited conceptual, theoretical and applied quizzes.',                       letter: 'Q',  color: 'royal' },
    { title: 'Learning analytics',    desc: 'Student, teacher and parent views of progress and performance.',                letter: 'A',  color: 'mint' },
  ],
  audiences: [
    { title: 'Schools and learning institutions', desc: 'Classroom use, deployment, access and analytics.', letter: 'S',  color: 'purple' },
    { title: 'Students and parents',              desc: 'Learning experiences, resources, quizzes and progress.', letter: 'P',  color: 'royal' },
    { title: 'Researchers and universities',      desc: 'Field studies, evidence and collaboration.',              letter: 'R',  color: 'cyan' },
    { title: 'Coaching institutes',               desc: 'Structured deployment for learning centres.',             letter: 'C',  color: 'mint' },
  ],
};
